import { APIRoute } from '@/modules/utils'
import { Insurance } from '@/data'

export const Route: APIRoute = {
  method: 'PUT',
  path: `/v2/customer/insurance/:insuranceId`,
}

export type Body = {
  insuranceData?: {
    id: string
  }
}

export type UrlParams = {
  insuranceId: string
}

export type Response = Insurance
